<div class="breadcrumb-wrapper">
    <ng-template ngFor let-route [ngForOf]="routes" let-last="last" let-first="first">
        <div class="link" [routerLink]="getRouteUrl(route)" [ngClass]="{ active: last }">
            <span class="icon" [hidden]="first"><i class="fas fa-angle-right"></i></span>
            {{ getRouteTitle(route) }}
        </div>
    </ng-template>
</div>
